var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', { is_active: _vm.is_active }],attrs:{"data-type":_vm.type}},[_c('i',{class:['fa', this.is_active ? 'fa-badge-check' : _vm.icon]}),_vm._v(" "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }